import type { ImgHTMLAttributes } from 'react';

type AkorepsWordmarkProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> & {
  alt?: string;
};

/** Brand wordmark from `/akoreps-name-logo.svg` (public). */
export function AkorepsWordmark({ className, alt = 'Akoreps', ...rest }: AkorepsWordmarkProps) {
  return <img src="/akoreps-name-logo.svg" alt={alt} className={className} {...rest} />;
}
